<template>
  <div class="video-format">
    <h2 class="format-title">{{ selectedEffects.length }} 项已选中</h2>
    <div class="label-button">
      <span class="label-button__label">画布中位置</span>
      <a-dropdown :trigger="['click']">
        <a-button class="label-button__btn position-editor-btn">
          <a-icon :component="icons.left" />
          对齐
        </a-button>
        <a-menu
          slot="overlay"
          class="timeline-filter-menu"
          @click="handleMenuClick"
        >
          <a-menu-item key="left">
            <a-icon :component="icons.left" />
            左侧
          </a-menu-item>
          <a-menu-item key="center">
            <a-icon :component="icons.center" />
            水平居中
          </a-menu-item>
          <a-menu-item key="right">
            <a-icon :component="icons.right" />
            右侧
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="top">
            <a-icon :component="icons.top" />
            顶部
          </a-menu-item>
          <a-menu-item key="middle">
            <a-icon :component="icons.middle" />
            竖直居中
          </a-menu-item>
          <a-menu-item key="bottom">
            <a-icon :component="icons.bottom" />
            底部
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <div class="label-button">
      <span class="label-button__label">相互对齐</span>
      <a-dropdown :trigger="['click']">
        <a-button class="label-button__btn position-editor-btn">
          <a-icon :component="icons.left" />
          对齐
        </a-button>
        <a-menu
          slot="overlay"
          class="timeline-filter-menu"
          @click="handleMutualAlignmentClick"
        >
          <a-menu-item key="left">
            <a-icon :component="icons.left" />
            左侧
          </a-menu-item>
          <a-menu-item key="center">
            <a-icon :component="icons.center" />
            水平居中
          </a-menu-item>
          <a-menu-item key="right">
            <a-icon :component="icons.right" />
            右侧
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="top">
            <a-icon :component="icons.top" />
            顶部
          </a-menu-item>
          <a-menu-item key="middle">
            <a-icon :component="icons.middle" />
            竖直居中
          </a-menu-item>
          <a-menu-item key="bottom">
            <a-icon :component="icons.bottom" />
            底部
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <label-input
      label="不透明度"
      v-model="displayOpacity"
      allowEmpty
      percentage
      :precision="0"
    />
    <label-input
      label="旋转"
      v-model="displayRotate"
      allowEmpty
      :deg="true"
      :step="0.01"
    />
    <!-- <label-input label="Opacity" v-model="displayOpacity" /> -->
    <template v-for="itemType in selectionTypeList">
      <collapse-title
        class="format-title format-title--secondary"
        :key="itemType"
        :title="`${typeNames[itemType]} (${selectionByType[itemType].length})`"
      >
        <template v-if="itemType === 'text'">
          <label-option
            :optionList="fontList"
            label="字体"
            v-model="displayTextFontFamily"
            allowEmpty
          />
          <label-input
            :step="0.05"
            v-model="displayTextLineHeight"
            label="行高"
            :min="0.5"
            allowEmpty
          />
          <text-gradient-editor
            v-model="displayTextColor"
            :gradient.sync="displayTextGradient"
            :disabled="displayTextFontAlpha !== false"
            label="文本填充"
          >
            <label-checkbox
              v-model="displayTextFontAlpha"
              :indeterminate="displayTextFontAlpha === ''"
              label="无填充"
              style="margin-top: 0"
            />
          </text-gradient-editor>
          <div class="color-gradient-editor preserve-label">
            <label-color
              v-model="displayTextStrokeColor"
              label="描边"
              :disabled="hasTextGradient"
            />
            <label-input
              :precision="0"
              label="宽度"
              v-model="displayTextStrokeWidth"
              style="margin-top: 0"
              :disabled="hasTextGradient"
            />
          </div>
          <label-radio-align label="段落对齐" v-model="displayTextAlign">
            <a-radio-group v-model="displayTextVerticalAlign">
              <a-radio-button value="top">
                <a-icon type="vertical-align-top" />
              </a-radio-button>
              <a-radio-button value="middle">
                <a-icon type="vertical-align-middle" />
              </a-radio-button>
              <a-radio-button value="bottom">
                <a-icon type="vertical-align-bottom" />
              </a-radio-button>
            </a-radio-group>
          </label-radio-align>
        </template>
        <template v-else-if="itemType === 'shape'">
          <color-gradient-editor
            label="填充"
            v-model="displayShapeColor"
            :gradient.sync="displayShapeGradient"
            showAlpha
            colorFormat="rgba"
          />
          <label-color
            label="边框颜色"
            class="color-gradient-editor"
            v-model="displayShapeStroke"
            :showAlpha="false"
          />
          <label-input
            allowEmpty
            percentage
            label="边框宽度"
            :max="100"
            :min="0"
            :step="0.1"
            :precision="1"
            v-model="displayShapeStrokeWidth"
          />
        </template>
        <template v-else-if="itemType === 'textContainer'">
          <label-option
            :optionList="fontList"
            label="字体"
            v-model="displayTextContainerFontFamily"
            allowEmpty
          />
          <label-input
            :step="0.05"
            v-model="displayTextContainerLineHeight"
            label="行高"
            :min="0.5"
            allowEmpty
          />
          <label-radio-align
            label="段落对齐"
            v-model="displayTextContainerAlign"
          >
            <a-radio-group v-model="displayTextContainerVerticalAlign">
              <a-radio-button value="top">
                <a-icon type="vertical-align-top" />
              </a-radio-button>
              <a-radio-button value="middle">
                <a-icon type="vertical-align-middle" />
              </a-radio-button>
              <a-radio-button value="bottom">
                <a-icon type="vertical-align-bottom" />
              </a-radio-button>
            </a-radio-group>
          </label-radio-align>
        </template>
        <template v-else>
          类型 {{ typeNames[itemType] }} 无可批量设置的属性。
        </template>
      </collapse-title>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import icons from '../base/alignmentIcons';
import CollapseTitle from '../base/CollapseTitle';
import LabelInput from '../base/LabelInput';
import LabelCheckbox from '../base/LabelCheckbox';
import LabelOption from '../base/LabelOption';
import TextGradientEditor from '../base/TextGradientEditor';
import LabelColor from '../base/LabelColor';
import LabelRadioAlign from '../base/LabelRadioAlign';
import ColorGradientEditor from '../base/ColorGradientEditor';
import '../base/LabelButton.vue?vue&type=style&index=0&lang=css';
import '../base/PositionEditor.vue?vue&type=style&index=0&lang=css';
import { rotateRect } from '../../utils';
import { labelPrefixes } from '../../utils/util';

export default {
  name: "VideoFormat",
  components: {
    CollapseTitle,
    LabelInput,
    LabelCheckbox,
    LabelOption,
    TextGradientEditor,
    LabelColor,
    LabelRadioAlign,
    ColorGradientEditor
  },
  data: function () {
    return {
      icons,
      typeNames: labelPrefixes
    };
  },
  computed: {
    ...mapState(['screenRatio']),
    fontList() {
      const { fontList } = this.$store.state;
      return fontList.map(item => ({
        name: this.$createElement(
          'span',
          {
            style: {
              fontFamily: item.font_name + ',"Segoe UI",-apple-system,sans-serif'
            }
          },
          item.font_name
        ),
        value: item.font_name
      }));
    },
    selectedEffects() {
      const { selectedEffectIds, effects } = this.$store.state;
      return selectedEffectIds.map(id => effects[id]);
    },
    screenWidth() {
      return 480 * this.screenRatio;
    },
    containerHeight() {
      return 480;
    },
    containerWidth() {
      return this.screenWidth;
    },
    selectionByType() {
      const ret = {
        text: [],
        image: [],
        video: [],
        lottie: [],
        sticker: [],
        shape: [],
        container: [],
        textContainer: [],
        group: [],
        icon: [],
        wordArt: []
      };

      this.selectedEffects.forEach(ef => {
        ret[ef.type].push(ef);
      });

      return ret;
    },
    selectionTypeList() {
      return Object.keys(this.selectionByType).filter(k => !!this.selectionByType[k].length);
    },
    displayOpacity: {
      get() {
        return this.getDisplayValue(this.selectedEffects, 'opacity');
      },
      set(value) {
        if (value || value === 0) {
          this.selectedEffects.forEach(ef => {
            ef.content.opacity = value;
          });
        }
      }
    },
    displayRotate: {
      get() {
        return this.getDisplayValue(this.selectedEffects, 'rotate');
      },
      set(value) {
        if (value || value === 0) {
          this.selectedEffects.forEach(ef => {
            ef.content.rotate = value;
          });
        }
      }
    },
    displayTextColor: {
      get() {
        return this.hasTextGradient ? '' : this.getDisplayValue(this.selectionByType.text, 'color');
      },
      set(value) {
        if (value) {
          this.selectionByType.text.forEach(ef => {
            ef.content.color = value;
            this.$set(ef.content, 'gradient', null);
          });
        }
      }
    },
    displayTextFontAlpha: {
      get() {
        return this.getDisplayValue(this.selectionByType.text, 'fontAlpha');
      },
      set(value) {
        if (value || value === false) {
          this.selectionByType.text.forEach(ef => {
            ef.content.fontAlpha = value;
          });
        }
      }
    },
    hasTextGradient() {
      return this.selectionByType.text.some(ef => !!ef.content.gradient);
    },
    displayTextGradient: {
      get() {
        let val;
        if (this.selectionByType.text.every((ef, i) => {
          const efc = ef.content;
          if (i === 0) {
            val = efc.gradient;
            return true;
          }
          return val && efc.gradient && ['type', 'angle', 'from', 'to'].every(k => efc.gradient[k] === val[k]);
        })) {
          return val;
        }
        return null;
      },
      set(value) {
        this.selectionByType.text.forEach(ef => {
          this.$set(ef.content, 'gradient', JSON.parse(JSON.stringify(value)));
        });
      }
    },
    displayTextFontFamily: {
      get() {
        return this.getDisplayValue(this.selectionByType.text, 'fontFamily');
      },
      set(value) {
        if (value) {
          this.selectionByType.text.forEach(ef => {
            ef.content.fontFamily = value;
          });
        }
      }
    },
    displayTextLineHeight: {
      get() {
        return this.getDisplayValue(this.selectionByType.text, 'lineHeight');
      },
      set(value) {
        if (value || value === 0) {
          this.selectionByType.text.forEach(ef => {
            ef.content.lineHeight = Math.max(value, .5);
          });
        }
      }
    },
    displayTextStrokeColor: {
      get() {
        return this.getDisplayValue(this.selectionByType.text, 'strokeColor');
      },
      set(value) {
        if (value) {
          this.selectionByType.text.forEach(ef => {
            ef.content.strokeColor = value;
          });
        }
      }
    },
    displayTextStrokeWidth: {
      get() {
        return this.getDisplayValue(this.selectionByType.text, 'strokeWidth');
      },
      set(value) {
        if (value || value === 0) {
          this.selectionByType.text.forEach(ef => {
            ef.content.strokeWidth = value;
          });
        }
      }
    },
    displayTextAlign: {
      get() {
        return this.getDisplayValue(this.selectionByType.text, 'align');
      },
      set(value) {
        if (value) {
          this.selectionByType.text.forEach(ef => {
            ef.content.align = value;
          });
        }
      }
    },
    displayTextVerticalAlign: {
      get() {
        return this.getDisplayValue(this.selectionByType.text, 'verticalAlign');
      },
      set(value) {
        if (value) {
          this.selectionByType.text.forEach(ef => {
            ef.content.verticalAlign = value;
          });
        }
      }
    },
    displayShapeColor: {
      get() {
        return this.hasShapeGradient ? '' : this.getDisplayValue(this.selectionByType.shape, 'color');
      },
      set(value) {
        if (value) {
          this.selectionByType.shape.forEach(ef => {
            ef.content.color = value;
            this.$set(ef.content, 'gradient', null);
          });
        }
      }
    },
    hasShapeGradient() {
      return this.selectionByType.shape.some(ef => !!ef.content.gradient);
    },
    displayShapeGradient: {
      get() {
        let val;
        if (this.selectionByType.shape.every((ef, i) => {
          const efc = ef.content;
          if (i === 0) {
            val = efc.gradient;
            return true;
          }
          return val && efc.gradient
            && ['type', 'x1', 'x2', 'y1', 'y2'].every(k => efc.gradient[k] === val[k])
            && efc.gradient.stops.length === val.stops.length
            && efc.gradient.stops.every((s, i) => ['offset', 'color'].every(k => s[k] === val.stops[i][k]));
        })) {
          return val;
        }
        return null;
      },
      set(value) {
        console.log(value);
        this.selectionByType.shape.forEach(ef => {
          this.$set(ef.content, 'gradient', JSON.parse(JSON.stringify(value)));
        });
      }
    },
    displayShapeStroke: {
      get() {
        return this.getDisplayValue(this.selectionByType.shape, 'stroke');
      },
      set(value) {
        if (value) {
          this.selectionByType.shape.forEach(ef => {
            ef.content.stroke = value;
          });
        }
      }
    },
    displayShapeStrokeWidth: {
      get() {
        return this.getDisplayValue(this.selectionByType.shape, 'strokeWidth');
      },
      set(value) {
        if (value || value === 0) {
          this.selectionByType.shape.forEach(ef => {
            ef.content.strokeWidth = value;
          });
        }
      }
    },
    displayTextContainerFontFamily: {
      get() {
        return this.getDisplayValue(this.selectionByType.textContainer, 'fontFamily');
      },
      set(value) {
        if (value) {
          this.selectionByType.textContainer.forEach(ef => {
            ef.content.fontFamily = value;
          });
        }
      }
    },
    displayTextContainerLineHeight: {
      get() {
        return this.getDisplayValue(this.selectionByType.textContainer, 'lineHeight');
      },
      set(value) {
        if (value || value === 0) {
          this.selectionByType.textContainer.forEach(ef => {
            ef.content.lineHeight = Math.max(value, .5);
          });
        }
      }
    },
    displayTextContainerAlign: {
      get() {
        return this.getDisplayValue(this.selectionByType.textContainer, 'align');
      },
      set(value) {
        if (value) {
          this.selectionByType.textContainer.forEach(ef => {
            ef.content.align = value;
          });
        }
      }
    },
    displayTextContainerVerticalAlign: {
      get() {
        return this.getDisplayValue(this.selectionByType.textContainer, 'verticalAlign');
      },
      set(value) {
        if (value) {
          this.selectionByType.textContainer.forEach(ef => {
            ef.content.verticalAlign = value;
          });
        }
      }
    }
  },
  methods: {
    handleMenuClick({ key }) {
      this.selectedEffects.forEach(ef => {
        const efc = ef.content;
        const rotated = rotateRect(efc);
        switch (key) {
          case 'top': {
            const rotatedTop = Math.min.apply(Math, rotated.map(p => p.y));
            efc.top = Math.round(efc.top - rotatedTop);
            break;
          }
          case 'middle':
            efc.top = Math.round((this.containerHeight - efc.height) / 2);
            break;
          case 'bottom': {
            const rotatedBottom = Math.max.apply(Math, rotated.map(p => p.y));
            efc.top = Math.round(efc.top + this.containerHeight - rotatedBottom);
            break;
          }
          case 'left': {
            const rotatedLeft = Math.min.apply(Math, rotated.map(p => p.x));
            efc.left = Math.round(efc.left - rotatedLeft);
            break;
          }
          case 'center':
            efc.left = Math.round((this.containerWidth - efc.width) / 2);
            break;
          case 'right': {
            const rotatedRight = Math.max.apply(Math, rotated.map(p => p.x));
            efc.left = Math.round(efc.left + this.containerWidth - rotatedRight);
            break;
          }
        }
      });
    },
    handleMutualAlignmentClick({ key }) {
      const allRotatedPoints = [].concat.apply([], this.selectedEffects.map(ef => rotateRect(ef.content)));
      const top = Math.min.apply(Math, allRotatedPoints.map(p => p.y));
      const bottom = Math.max.apply(Math, allRotatedPoints.map(p => p.y));
      const left = Math.min.apply(Math, allRotatedPoints.map(p => p.x));
      const right = Math.max.apply(Math, allRotatedPoints.map(p => p.x));

      this.selectedEffects.forEach(ef => {
        const efc = ef.content;
        const rotated = rotateRect(efc);
        switch (key) {
          case 'top': {
            const rotatedTop = Math.min.apply(Math, rotated.map(p => p.y));
            efc.top = Math.round(efc.top - rotatedTop + top);
            break;
          }
          case 'middle':
            efc.top = (top + bottom - efc.height) / 2;
            break;
          case 'bottom': {
            const rotatedBottom = Math.max.apply(Math, rotated.map(p => p.y));
            efc.top = Math.round(efc.top - rotatedBottom + bottom);
            break;
          }
          case 'left': {
            const rotatedLeft = Math.min.apply(Math, rotated.map(p => p.x));
            efc.left = Math.round(efc.left - rotatedLeft + left);
            break;
          }
          case 'center':
            efc.left = (left + right - efc.width) / 2;
            break;
          case 'right': {
            const rotatedRight = Math.max.apply(Math, rotated.map(p => p.x));
            efc.left = Math.round(efc.left - rotatedRight + right);
            break;
          }
        }
      });
    },
    getDisplayValue(arr, key) {
      let val;
      if (arr.every((ef, i) => {
        const efc = ef.content;
        if (i === 0) {
          val = efc[key];
          return true;
        }
        return efc[key] === val;
      })) {
        return val;
      }
      return '';
    }
  },
  watch: {

  }
}
</script>

<style scoped>
.video-format {
  background: rgba(248, 248, 248, 1);
  padding: 13px;
  box-sizing: border-box;
}

.format-title {
  font-size: 14px;
  font-weight: 400;
  /* color: rgba(101, 102, 103, 1); */
  margin: 0;
}

.format-title--secondary {
  margin-top: 12px;
}

.preserve-label ::v-deep .label {
  margin-right: 5px;
}
</style>
